import { render } from "./BirthdayLabel.vue?vue&type=template&id=feb490a2"
import script from "./BirthdayLabel.vue?vue&type=script&lang=js"
export * from "./BirthdayLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__